import { motion } from "framer-motion";
import { Phone, MessageCircle, Mail, MapPin, ArrowUpRight } from "lucide-react";

const CONTACTS = [
  {
    id: "telefono",
    icon: Phone,
    title: "Telefono",
    value: "375 539 8236",
    sub: "Chiamaci per un preventivo immediato",
    href: "tel:+393755398236",
    accent: "bg-neon/10 border-neon/40 text-neon",
  },
  {
    id: "whatsapp",
    icon: MessageCircle,
    imgSrc: "/whatsapp.svg",
    title: "WhatsApp",
    value: "375 539 8236",
    sub: "Scrivici in chat: risposta rapida, anche con foto",
    href: "https://wa.me/393755398236",
    accent: "bg-[#25D366]/10 border-[#25D366]/40 text-[#1E9E4F]",
  },
  {
    id: "email",
    icon: Mail,
    title: "Email",
    value: "HELPLYSRLS.LE@GMAIL.COM",
    sub: "Scrivici quando vuoi, ti rispondiamo entro 48 ore",
    href: "mailto:HELPLYSRLS.LE@GMAIL.COM",
    accent: "bg-pulse/10 border-pulse/40 text-pulse",
  },
];

export default function Contatti() {
  return (
    <section id="contatti" data-testid="contatti-section" className="relative py-24 lg:py-32">
      <div
        aria-hidden
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at 50% 0%, rgba(53,101,174,0.10), transparent 60%)",
        }}
      />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="text-center font-mono text-xs uppercase tracking-[0.25em] text-neon"
        >
          {"// Contatti Diretti"}
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          className="mx-auto mt-4 max-w-2xl text-center font-display text-2xl font-bold leading-tight tracking-tight sm:text-3xl lg:text-4xl"
        >
          Parliamone ora. <span className="text-pulse">Rispondiamo subito.</span>
        </motion.h2>

        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-3">
          {CONTACTS.map((c, i) => (
            <motion.a
              key={c.id}
              data-testid={`contact-${c.id}`}
              href={c.href}
              target={c.href.startsWith("http") ? "_blank" : undefined}
              rel={c.href.startsWith("http") ? "noopener noreferrer" : undefined}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.8, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              className="group flex flex-col items-center rounded-2xl border border-[#D9E4F5] bg-white p-8 text-center shadow-[0_8px_32px_rgba(22,52,95,0.08)] transition-all duration-500 hover:-translate-y-2 hover:border-neon/50 hover:shadow-[0_20px_60px_rgba(53,101,174,0.18)] lg:p-10"
            >
              <span className={`flex h-16 w-16 items-center justify-center rounded-2xl border ${c.accent}`}>
                {c.imgSrc ? (
                  <img src={c.imgSrc} alt="Logo WhatsApp" className="h-8 w-8" />
                ) : (
                  <c.icon className="h-7 w-7" />
                )}
              </span>
              <span className="mt-5 font-mono text-xs uppercase tracking-[0.25em] text-slate-500">
                {c.title}
              </span>
              <span className={`mt-2 break-all font-display font-bold text-[#16345F] ${c.id === "email" ? "text-sm sm:text-base" : "text-lg sm:text-xl"}`}>
                {c.value}
              </span>
              <span className="mt-3 text-sm leading-relaxed text-slate-600">{c.sub}</span>
              <span className="mt-6 block h-px w-10 bg-neon/50 transition-all duration-500 group-hover:w-24 group-hover:bg-neon" />
            </motion.a>
          ))}
        </div>

        <motion.div
          data-testid="social-section"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="mt-8 flex flex-col items-center gap-5 rounded-2xl border border-[#D9E4F5] bg-white p-8 text-center shadow-[0_8px_32px_rgba(22,52,95,0.08)]"
        >
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500">
            Seguici sui Social
          </p>
          <div className="flex items-center gap-4">
            <a
              data-testid="social-facebook"
              href="https://www.facebook.com/profile.php?id=61574314433521"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Pagina Facebook HELPLY"
              className="flex h-14 w-14 items-center justify-center rounded-2xl border border-[#1877F2]/40 bg-[#1877F2]/10 transition-all duration-300 hover:scale-110 hover:border-[#1877F2]"
            >
              <img src="/facebook.svg" alt="Facebook" className="h-7 w-7" />
            </a>
            <a
              data-testid="social-instagram"
              href="https://www.instagram.com/helply_srls/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Pagina Instagram HELPLY"
              className="flex h-14 w-14 items-center justify-center rounded-2xl border border-[#E1306C]/40 bg-[#E1306C]/10 transition-all duration-300 hover:scale-110 hover:border-[#E1306C]"
            >
              <img src="/instagram.svg" alt="Instagram" className="h-7 w-7" />
            </a>
          </div>
          <p className="text-xs text-slate-500">Novità, lavori e offerte in tempo reale</p>
        </motion.div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-5">
          <motion.div
            data-testid="contact-address"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="flex flex-col justify-center rounded-2xl border border-[#D9E4F5] bg-white p-8 shadow-[0_8px_32px_rgba(22,52,95,0.08)] lg:col-span-2 lg:p-10"
          >
            <span className="flex h-16 w-16 items-center justify-center rounded-2xl border border-neon/40 bg-neon/10">
              <MapPin className="h-7 w-7 text-neon" />
            </span>
            <p className="mt-5 font-mono text-xs uppercase tracking-[0.25em] text-slate-500">
              La Nostra Sede
            </p>
            <p className="mt-2 font-display text-xl font-bold leading-snug text-[#16345F]">
              Via Gabriele Caiulo 17–19
              <br />
              73100 Lecce (LE)
            </p>
            <p className="mt-3 text-sm leading-relaxed text-slate-600">
              Operiamo a Lecce e in tutta la provincia. Passa a trovarci o fissiamo un
              sopralluogo gratuito direttamente da te.
            </p>
            <a
              data-testid="contact-maps-link"
              href="https://www.google.com/maps/search/?api=1&query=Via+Gabriele+Caiulo+17,+73100+Lecce"
              target="_blank"
              rel="noopener noreferrer"
              className="group mt-6 inline-flex w-fit items-center gap-2 rounded-full border border-[#C9D8EE] px-5 py-2.5 font-mono text-xs uppercase tracking-[0.15em] text-[#16345F] transition-all duration-300 hover:border-neon hover:text-neon"
            >
              Apri in Google Maps
              <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8, delay: 0.12, ease: [0.16, 1, 0.3, 1] }}
            className="overflow-hidden rounded-2xl border border-[#D9E4F5] shadow-[0_8px_32px_rgba(22,52,95,0.08)] lg:col-span-3"
          >
            <iframe
              title="Mappa sede HELPLY SRLS — Via Gabriele Caiulo 17-19, Lecce"
              data-testid="contact-map"
              src="https://www.openstreetmap.org/export/embed.html?bbox=18.1882%2C40.3440%2C18.2002%2C40.3520&layer=mapnik&marker=40.3480084%2C18.1941672"
              loading="lazy"
              className="h-full min-h-[360px] w-full"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
